// services/categories.js
import axiosInstance from './axiosInstance';

const CATEGORIES_API_URL = '/categories';

const categoriesService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${CATEGORIES_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async set(categoryData) {
    try {
      const response = await axiosInstance.get(`${CATEGORIES_API_URL}/set.php`, {
        params: categoryData
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar categoria:', error);
      throw error;
    }
  },

  async unset(idempresa, idcategoria) {
    try {
      const response = await axiosInstance.get(`${CATEGORIES_API_URL}/unset.php?idempresa=${idempresa}&idcategoria=${idcategoria}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export default categoriesService;
